import { render, staticRenderFns } from "./Decoration2.vue?vue&type=template&id=eb35abe0&scoped=true"
import script from "./Decoration2.vue?vue&type=script&lang=js"
export * from "./Decoration2.vue?vue&type=script&lang=js"
import style0 from "./Decoration2.vue?vue&type=style&index=0&id=eb35abe0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb35abe0",
  null
  
)

export default component.exports